export function enumToOptions<T extends Record<string, string>>(enumObj: T) {
  return Object.entries(enumObj).map(([key, value]) => ({
    label: key,
    value
  }))
}

export function formatNumber(value: number): string {
  return new Intl.NumberFormat('sv-SE').format(value);
}